import script from "./SelectBrand.vue?vue&type=script&lang=ts&setup=true"
export * from "./SelectBrand.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__